import * as icons from '@sloyd/icons';
import { Wrapper } from './Cost.style';

export type CostProps = {
  cost: number;
};

export function Cost(props: CostProps) {
  const { cost } = props;

  return (
    <Wrapper className='Cost-wrapper' data-testid='Cost-wrapper'>
      <icons.IconCoins size={20} stroke={1.5} />
      {cost}
    </Wrapper>
  );
}

export default Cost;
